import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import axiosInstance from "../../interceptor/axiosInstance";
import { toast } from '../Library/SubMenus/MCQAssessment/toastUtils';

const AssignedList = ({ user, onClose }) => {
  const [assignedTests, setAssignedTests] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAssignedTests = async () => {
      if (!user?.email) {
        toast.error('Invalid User', 'User information is missing.');
        onClose();
        return;
      }

      setLoading(true);
      try {
        const response = await axiosInstance.get(
          `assign/bulk-assign/?name=${user.email}&page_size=100`
        );
        setAssignedTests(response.data?.data?.results || []);
      } catch (error) {
        toast.error('Fetch Failed', 'Failed to load assigned tests. Please try again.');
      } finally {
        setLoading(false);
      }
    };

    fetchAssignedTests();
  }, [user, onClose]);

  return ReactDOM.createPortal(
    <div className="assigned-list-modal-overlay">
      <div className="assigned-list-modal-container">
        {/* Header */}
        <div className="assigned-list-modal-header">
          <div className="assigned-list-modal-header-content">
            <h2>📚 Assigned Tests</h2>
            <p className="assigned-list-modal-user-info">
              User: <strong>{user?.first_name} {user?.last_name}</strong> ({user?.email})
            </p>
          </div>
          <button 
            className="assigned-list-modal-close" 
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div className="assigned-list-modal-content">
          {loading ? (
            <div className="assigned-list-modal-loading">
              <div className="assigned-list-modal-spinner"></div>
              <p>Loading assigned tests...</p>
            </div>
          ) : assignedTests.length > 0 ? (
            <>
              <div className="assigned-list-modal-info">
                <span className="assigned-list-count-badge">
                  {assignedTests.length} {assignedTests.length === 1 ? 'Test' : 'Tests'} Assigned
                </span>
              </div>
              
              <div className="assigned-list-table-wrapper">
                <table className="assigned-list-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Test Name</th>
                      <th>Status</th>
                      <th>Assigned Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {assignedTests.map((assignment, index) => (
                      <tr key={assignment.id || index}>
                        <td className="assigned-list-index">{index + 1}</td>
                        <td className="assigned-list-test-name">
                          {assignment.test?.name || "No test name available"}
                        </td>
                        <td>
                          <span className={`assigned-list-status ${assignment.status ? 'assigned-list-status-' + assignment.status.toLowerCase().replace(/\s+/g, '-') : 'assigned-list-status-unknown'}`}>
                            {assignment.status || "Pending"}
                          </span>
                        </td>
                        <td className="assigned-list-date">
                          {assignment.created_at 
                            ? new Date(assignment.created_at).toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'short',
                                day: 'numeric'
                              })
                            : 'N/A'
                          }
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          ) : (
            <div className="assigned-list-modal-empty">
              <div className="assigned-list-empty-icon">📭</div>
              <h3>No Tests Assigned</h3>
              <p>This user hasn't been assigned any tests yet.</p>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="assigned-list-modal-footer">
          <button 
            className="assigned-list-modal-close-btn" 
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AssignedList;
